//#region IMPORT
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1 } from './COU_BASIC_ColumnDefs';
//#endregion

function COU_BASIC(props) {
  const columnDefs1 = getColumnDefs1({
    plTypeList: props.plTypeList,
    gridRef1: props.gridRef1,
    rowData1: props.rowData1,
    selectedRowNosRef1: props.selectedRowNosRef1,
    lastCheckedIndexRef1: props.lastCheckedIndexRef1,
    handleRowSelection1: props.handleRowSelection1,
    DeleteNewRow1: props.DeleteNewRow1,
    RestoreRow1: props.RestoreRow1,
  });

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="CompanyMenu"
          printYn="N"
          searchClick={(e) => {
            if (!props.validateSelection()) return;
            props.gridRef1.current?.api?.setQuickFilter(e);
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;
            props.SaveLogic1();
          }}
          conditions={[
            {
              type: 'combo',
              name: '회사',
              items: props.coList ?? [],
              value: props.coCd ?? '',
              onChange: (e) => {
                props.handleCoChange(e);
                props.SearchLogic1?.();
              },
            },
          ]}
          grids={
            <BusinessGridCommon
              getRowId={(params) => String(params.data?.no ?? '')}
              gridRef={props.gridRef1}
              title1="회사별 메뉴정보"
              columnDefs={columnDefs1}
              rowData={props.rowData1}
              setSelectedRowData={props.setSelectedRowData1}
              setChangedRowData={props.setChangedRowData1}
              stopEditingWhenCellsLoseFocus={false}
              refreshClick1={() => {
                if (!props.validateSelection()) return;
                props.RefreshLogic1?.();
              }}
              addClick1={() => {
                if (!props.validateSelection()) return;

                if (props.coCd === '전체') {
                  props.dispatch(
                    props.showSnackbar({
                      message: '회사를 선택 하세요.',
                      type: 'warning',
                    })
                  );
                  return;
                }

                GridFunctions.addClick(props.gridRef1, {}, {});
                const api = props.gridRef1.current.api;
                const newRowNode = api.getDisplayedRowAtIndex(0);

                if (newRowNode) {
                  const { coCd, coList } = {
                    coCd: props.coCd,
                    coList: props.coList ?? [],
                  };
                  const selectedCo = coList.find((item) => item.value === coCd);
                  newRowNode.setDataValue('CO_CD', coCd);
                  newRowNode.setDataValue(
                    'CO_NM',
                    selectedCo ? selectedCo.name : ''
                  );
                }
              }}
              deleteClick1={() => {
                if (!props.validateSelection()) return;
                props.DeleteClick1?.();
              }}
              onCellClicked={(e) => {
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;
                const isCheckboxClick = e.event?.target?.type === 'checkbox';
                const colId =
                  e.column?.getColId?.() ?? e.colDef?.field ?? '';

                if (!isCheckboxClick) {
                  gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                  if (colId !== 'PL_TYPE') {
                    gridApi.setFocusedCell(clickedRowIndex, 'PL_TYPE');
                  }

                  const copied = JSON.parse(JSON.stringify(e.data));
                  props.handleRowSelection1(copied, clickedRowIndex);

                  gridApi
                    .getDisplayedRowAtIndex(clickedRowIndex)
                    ?.setSelected(true, false);
                }
              }}
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.selectedRowNosRef1.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData1(selectedData);
              }}
              onCellValueChanged={(e) => {
                const key = e.data.no;

                props.setChangedRowData1?.((prev) => {
                  const filtered = prev.filter((row) => row.no !== key);
                  return [...filtered, { ...e.data, editYn: 'Y' }];
                });
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default COU_BASIC;
